module.exports = __webpack_public_path__ + "static/media/AptAutobookActive.de497864.svg";